import React from 'react';

/**
 * Read-only rendering of a content block's value, shaped by its content_format.
 *
 * - terms_list : array of { kind: 'heading'|'body'|'note', text } clauses.
 * - html       : raw HTML / ReportLab markup — rendered as escaped monospace
 *                text (never dangerouslySetInnerHTML: it is generator markup,
 *                and injecting stored HTML would be an XSS vector).
 * - plain      : preformatted text.
 */
const isEmpty = (value) => {
    if (value === null || value === undefined) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'string') return value.trim() === '';
    return false;
};

const ValuePreview = ({ value, format }) => {
    if (isEmpty(value)) {
        return <div className="thq-value-empty">No content set.</div>;
    }

    if (format === 'terms_list' && Array.isArray(value)) {
        return (
            <div className="thq-terms-preview">
                {value.map((item, index) => {
                    const kind = item?.kind || 'body';
                    return (
                        <div key={index} className={`thq-term thq-term-${kind}`}>
                            {item?.text || ''}
                        </div>
                    );
                })}
            </div>
        );
    }

    if (format === 'html') {
        return <pre className="thq-code-preview">{String(value)}</pre>;
    }

    return <div className="thq-plain-preview">{String(value)}</div>;
};

export default ValuePreview;
